import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import GridTable from 'components/shared/gridTable';
import NotificationCard from 'components/shared/notificationCard';
import SectionTitle from 'components/shared/sectionTitle';
import { isArray, isArrayEmpty } from 'utility/helpers';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  section: {
    marginBottom: spacing(8),
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(2),
    marginBottom: spacing(3),
  },
  noResults: {
    marginTop: spacing(2),
  },
  table: {
    '& .actions-cell': {
      overflow: 'visible',
      paddingLeft: 0,
      paddingTop: spacing(2),
      paddingBottom: spacing(2),
      paddingRight: spacing(1),

      [breakpoints.up('xLg')]: {
        paddingRight: spacing(3),
      },
    },
    '& .actions-cell .row-cell-value': {
      overflow: 'visible',
    },
  },
}));

const SuccessionPoolSection = ({
  translations,
  title,
  actions = null,
  headers,
  headerActions = [],
  rows,
  noResulltsMessage,
  hasLoadMore = false,
  onLoadMore = () => {},
}) => {
  const classes = useStyles();
  const hasRows = isArray(rows) && !isArrayEmpty(rows);

  return (
    <section className={classes.section}>
      <div className={classes.sectionHeader}>
        <SectionTitle title={title} variant="h4" />
        {actions}
      </div>
      {hasRows && (
        <GridTable
          className={classes.table}
          translations={translations}
          headers={headers}
          headerActions={headerActions}
          rows={rows}
          hasLoadMore={hasLoadMore}
          onLoadMore={onLoadMore}
        />
      )}
      <NotificationCard
        className={classes.noResults}
        content={noResulltsMessage}
        shouldFade={!hasRows}
        shouldFadeOutInstant
      />
    </section>
  );
};

SuccessionPoolSection.propTypes = {
  translations: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  actions: PropTypes.node,
  headers: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerActions: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  noResulltsMessage: PropTypes.string.isRequired,
  hasLoadMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
};

export default SuccessionPoolSection;
